import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-faq-submit-waiver-premium-claim'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Apply for Early Payment Benefit
        </Typography>
        <Typography nextElement='typography'>
          The Early Payment Benefit &#40;EPB&#41; advances a portion of the death benefit if the insured has a terminal illness and an expected lifespan of six months or less. The company offers this program so that terminally ill insureds can use the advanced death benefit to help with the financial burden of a
          serious illness.
        </Typography>
        <Typography nextElement='typography'>
          EPB is not available in the following states &#40;due to state approval&#41;:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Illinois' },
            { bulletText: 'Indiana' },
            { bulletText: 'Kentucky' },
            { bulletText: 'Massachusetts' },
            { bulletText: 'New Jersey' },
            { bulletText: 'New York' },
            { bulletText: 'Pennsylvania' },
            { bulletText: 'Texas' },
            { bulletText: 'Vermont' },
          ]}
        />
        <Typography nextElement='typography'>
          EPB is not available on the following contracts:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Variable Life' },
            { bulletText: 'Universal Life' },
            { bulletText: 'Decreasing Term' },
            { bulletText: 'Extended Term' },
            { bulletText: 'Most business owned policies' },
            { bulletText: 'Joint Life and Joint CompLife before the first death' },
            { bulletText: 'Term policies beyond the conversion period' },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Amount Available
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: <>Total insurance in force must equal at least &#36;50,000&#40;for all qualifying policies&#41;</> },
            { bulletText: <>Maximum percentage that can be advanced per policy is 50&#37; of death benefit</> },
            { bulletText: <>Maximum amount that can be advanced for all qualifying policies is &#36;250,000</> },
            { bulletText: <>Minimum advance is &#36;10,000</> },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          How to Apply
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual administers the benefit at the policyowner&#39;s request. You must complete
          the Early Payment Benefit form. We will need medical information confirming that the person insured
          has less than six months to live. For a copy of the form:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Contact your representative' },
            {
              bulletText: <>Contact Northwestern Mutual directly at <Link
                id='life-insurance-faq-early-payment-benefit-number-link'
                ariaLabel='Call to request copy of the Early Payment Benefit form'
                linkUrl='tel:8003888123'
                variant='primaryDeemphasize'>
                1&#45;800&#45;388&#45;8123
              </Link>, <time dateTime='7:00-06:00'>7am</time>&#8211;<time dateTime='18:00-06:00'>6pm</time> CT, Monday &#8211; Friday</>,
            },
            {
              bulletText: <>The Internal Revenue Code, as amended by the Health Insurance Portability and Accountability Act
                &#40;HIPAA&#41; of 1996, provides that qualified accelerated death benefits are treated as tax&#45;free death benefits, and the addition of a qualified accelerated death benefit to a life insurance contract is not treated as an exchange or material change for tax purposes.</>,
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
